
import { Component, Vue } from "vue-property-decorator";
import * as Model from "@gigalot/data-models";
const lodash = require("lodash");
import { EventBus } from "../eventBus";

import { DimssaButton, ButtonState } from "@/components/shared/dimssa-button.vue";

@Component({
  components: {
    DimssaButton,
  },
})
export default class FeedDeliverySummary extends Vue {
  name = "feedDeliverySummary";
  feedDeliverySummary: any[] = [];
  loading = false;
  mixingScheduledItems: any = [];
  mixResults: any = [];
  rationPlans: Model.RationPlan[] = [];
  rationColorMap: Record<string, string> = {};
  search = "";

  headers = [
    {
      text: "Ration",
      value: "key",
      align: "start",
      sortable: true,
      filterable: true,
      divider: true,
    },
    {
      text: "Total (kg)",
      value: "feedAllocated",
      align: "end",
      sortable: true,
      filterable: true,
      divider: true,
    },
    {
      text: "Feeding Completed (kg)",
      value: "actualFed",
      align: "end",
      sortable: true,
      filterable: true,
      divider: true,
    },
    {
      text: "Still To Feed (kg)",
      value: "stillToFeed",
      align: "end",
      sortable: true,
      filterable: true,
      divider: true,
    },
    {
      text: "Loading Completed (kg)",
      value: "actualLoaded",
      align: "end",
      sortable: true,
      filterable: true,
      divider: true,
    },
    {
      text: "Scheduled Loads",
      value: "totalLoads",
      align: "end",
      sortable: true,
      filterable: true,
      divider: true,
    },
    {
      text: "Completed Loads",
      value: "completedLoads",
      align: "end",
      sortable: true,
      filterable: true,
      divider: true,
    },
  ];

  feedSchedules = [];
  urlws = "wss://pi.gigalot.systems:7778/api/ws";
  options = {};

  variables = {};
  operationName = null;

  mounted() {
    this.$store.dispatch("user/addFirebaseCallback", this.getFeedSchedule);
    setInterval(() => {
      this.getFeedSchedule();
    }, 30000);
  }

  get summaryTotals() {
    return this.feedDeliverySummary.reduce(
      (acc, item: any) => {
        acc.feedAllocated += Number(item.feedAllocated) || 0;
        acc.actualFed += Number(item.actualFed) || 0;
        acc.stillToFeed += Number(item.stillToFeed) || 0;
        acc.actualLoaded += Number(item.actualLoaded) || 0;
        acc.totalLoads += Number(item.totalLoads) || 0;
        acc.completedLoads += Number(item.completedLoads) || 0;
        return acc;
      },
      {
        feedAllocated: 0,
        actualFed: 0,
        stillToFeed: 0,
        actualLoaded: 0,
        totalLoads: 0,
        completedLoads: 0,
      }
    );
  }

  get themeClass(): string {
    return this.$store.state.lightDarkMode;
  }

  numberWithCommas(value: number | string) {
    if (value === null || value === undefined) return "0";
    return `${Math.round(Number(value))}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  formatNumber(value: number) {
    return this.numberWithCommas(value);
  }

  formatKg(value: number) {
    return `${this.numberWithCommas(value)} kg`;
  }

  normalizeColor(color?: string) {
    return color ? color.toLowerCase() : "grey darken-1";
  }

  buildRationColorMap() {
    const map: Record<string, string> = {};
    this.rationPlans.forEach((plan: Model.RationPlan) => {
      plan?.rationItems?.forEach((item: any) => {
        if (item?.ration && item?.colour) {
          map[item.ration] = item.colour;
        }
      });
    });
    this.rationColorMap = map;
  }

  getRationColor(ration: string) {
    return this.rationColorMap[ration] || "";
  }

  buildSummaryRows() {
    const grouped = lodash.groupBy(this.feedSchedules, (si: any) => si.ration);
    const rows = Object.keys(grouped).map((ration) => {
      const items = grouped[ration];
      const aggregated = items.reduce(
        (acc: any, cur: any) => {
          acc.actualFed += Number(cur.actualFed) || 0;
          acc.feedAllocated += Number(cur.feedAllocated) || 0;
          return acc;
        },
        { actualFed: 0, feedAllocated: 0 }
      );

      const matchingLoads = (this.mixingScheduledItems || []).filter((item: Model.MixingScheduleItem) => {
        return item.loadType !== "Dump" && item.ration === ration;
      });

      const matchingMixes = (this.mixResults || []).filter((mix: Model.MixResult) => {
        return mix.RationCode === ration;
      });

      const actualLoaded = matchingMixes.reduce((counter: number, mix: Model.MixResult) => {
        return counter + (Number(mix.ActualWeight) || 0);
      }, 0);

      return {
        key: ration,
        color: this.getRationColor(ration),
        actualFed: aggregated.actualFed,
        feedAllocated: aggregated.feedAllocated,
        stillToFeed: aggregated.feedAllocated - aggregated.actualFed,
        totalLoads: matchingLoads.length,
        completedLoads: matchingMixes.length,
        actualLoaded,
      };
    });

    this.feedDeliverySummary = rows.sort((a, b) => a.key.localeCompare(b.key));
  }

  async getFeedSchedule() {
    try {
      console.log("FeedSchedule()");
      this.loading = true;
      let gql = `query($guid:String!){
        FeedSchedule(guid:$guid){
       typename
          guid
          feedingScheduleItems{
            typename
            guid
            kraalId
            ration
            feedAllocated
            actualFed
            sequence
            activeFeed
            feedAllocations{
              typename
              feedAllocated
              actualFed
              active
              allocated
            }
          }
        }
   
    MixingSchedule(guid:$guid){
          typename
          guid
          MixingScheduleItems{
            typename
            guid
            mixerCapacity
            ration
            rationGuid
            loadType
          }
        }

        MixResults(guid:$guid){
           guid
           MixID
           RationCode
           FeedDate
           MixStartTime
           MixEndTime
           RationWeightRequired
           MixStatus
           ActualWeight
           TractorID
           CallManagerID
           CallManagerAction
           LoadDuration
        }
        RationPlans(guid:$guid) {
          guid
          rationItems{
            ration
            colour
          }
        }
      }`;

      let json = await this.$store.dispatch("graphQl", { gql, variables: { guid: this.$store.state.user.location.guid } });
      this.feedSchedules = json.data.FeedSchedule?.feedingScheduleItems ?? [];
      this.mixingScheduledItems = json.data.MixingSchedule?.MixingScheduleItems ?? [];
      this.mixResults = json.data.MixResults ?? [];
      this.rationPlans = json.data.RationPlans ?? [];
      this.buildRationColorMap();
      this.buildSummaryRows();
    } catch (err) {
      console.log("getFeedSchedule -> error: " + err);
    }
    this.loading = false;

    EventBus.$emit("component-a-done");
  }
}
